module.exports = __webpack_public_path__ + "media/images/flags/MT-09112730809a6a04b8218f91f8877f28.svg";